import { useCallback, useContext, useEffect } from "react";

import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import {
  InquiryContext,
  PropertyListingContext,
  SearchContext,
  navigateTo,
} from "components/store/source";
import { buildingListingTrackingEvents } from "components/store/source/tracking_events";

import Quote from "./Quote";

function QuoteContainer(props) {
  const { createInquiry, loading, hasError, inquiry } =
    useContext(InquiryContext);
  const {
    listing: { id: listingId },
  } = useContext(PropertyListingContext);
  const {
    criteria: {
      checkIn,
      checkOut,
      guests: { guests },
    },
  } = useContext(SearchContext);
  const { analytics } = useAnalyticsTracker();

  // Side Effect: Routing Change
  useEffect(() => {
    if (inquiry) {
      navigateTo(inquiry.payPath);
    }
  }, [inquiry]);

  const onClick = collectionId => async () => {
    await createInquiry({
      listingId: listingId,
      collectionId: collectionId,
      checkInDate: checkIn,
      checkOutDate: checkOut,
      promoCodes: [],
      buildingListing: true,
      guestNb: guests,
    });
  };

  const onSelectButtonClick = useCallback(
    collectionId => {
      analytics.track(buildingListingTrackingEvents.selectCtaClicked, {
        collectionId,
        listingId,
        buildingListing: true,
      });
    },
    [analytics, listingId],
  );

  const onTooltipOpen = useCallback(
    collectionId => {
      analytics.track(buildingListingTrackingEvents.quoteTooltipClicked, {
        collectionId,
        listingId,
        buildingListing: true,
      });
    },
    [analytics, listingId],
  );

  return (
    <Quote
      loading={loading}
      hasError={hasError}
      onTooltipOpen={onTooltipOpen}
      onSelectButtonClick={onSelectButtonClick}
      onClick={onClick}
      {...props}
    />
  );
}

export default QuoteContainer;
